import { useEffect, useState } from "react";
import { createModel } from "hox";
import { ITreeData } from "../../base/dict/dictModel";
import { IMdDictFields } from "../../base/dict/dictService";
import { IMdOrgDetail, orgService } from "../../base/org/orgService";
// import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
// import { useGlobalModel } from "@/model/globalModel";

export enum ActionTypeEnum {
  WAITCOLLECT,
  ALREADYCOLLECT,
  NULL
}
type OptionDsType = {
  label: string,
  value: string,
}

type labelsType = {
  [proppName: string]: string;
}
export const useCashCollectModel = createModel(function () {
  // const { resourceAuth } = useGlobalModel();
  const [actionType, setActionType] = useState(ActionTypeEnum.WAITCOLLECT) // 选中展示模块

  //默认值 会去查有没有分配权限， 并取到第一个权限为展示
  // const [actionType, setActionType] = useState(() => {
  //   //所有tab权限
  //   let authArr = [ResourceAuthEnum.CASH_RECEI_WILL, ResourceAuthEnum.CASH_RECEI_DONE];
  //   //过滤出来所有分配的权限；
  //   let findAuth = resourceAuth.filter(item => authArr.indexOf(item as ResourceAuthEnum) >= 0);
  //   if (!findAuth.length) return ActionTypeEnum.NULL;
  //   switch (findAuth[0]) {
  //     case ResourceAuthEnum.CASH_RECEI_WILL:
  //       return ActionTypeEnum.WAITCOLLECT;
  //     case ResourceAuthEnum.CASH_RECEI_DONE:
  //       return ActionTypeEnum.ALREADYCOLLECT;
  //     default:
  //       return ActionTypeEnum.NULL;
  //   }
  // })

  const [orgDs, setOrgDs] = useState<ITreeData<IMdOrgDetail>[]>();
  const [beDs, setBeDs] = useState<OptionDsType[]>();
  const [payMethodLabels, setPayMethodLabels] = useState<labelsType>({});
  const [userTypeLabels, setUserTypeLabels] = useState<labelsType>({});
  const [payMethodDs, setPayMethodDs] = useState<ITreeData<IMdDictFields>[]>();



  return {
    /***field***/
    actionType,
    orgDs,
    beDs,
    payMethodDs,
    payMethodLabels,
    userTypeLabels,
    /***method***/
    setActionType,
    setOrgDs,
    setBeDs,
    setPayMethodDs,
    setPayMethodLabels,
    setUserTypeLabels,
  }
});
